import React, { useEffect } from "react";
import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStatus } from "../hooks/Authorize";
import { saveIntendedRoute } from "../Worksuite/auth/intendedRoute";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const { status } = useAuthStatus();
  const fullPath = `${location.pathname}${location.search}${location.hash}`;
  useEffect(() => {
    if (status === "unauthenticated") saveIntendedRoute(fullPath);
  }, [fullPath, status]);

  if (status === "initializing") return <Box minHeight="100dvh" display="grid" sx={{ placeItems: "center" }}><CircularProgress /></Box>;
  if (status === "unauthenticated") return <Navigate to="/login" state={{ from: fullPath }} replace />;
  if (status === "unverifiable") return <Box minHeight="100dvh" display="grid" sx={{ placeItems: "center", p: 3 }}><Box maxWidth={520}><Alert severity="warning"><Typography fontWeight={700}>Accounts is temporarily unavailable</Typography><Typography variant="body2" sx={{ mt: 1 }}>Your saved session is present, but Campaigns could not verify it. Retry instead of signing in again.</Typography><Button onClick={() => window.location.reload()} sx={{ mt: 1.5 }}>Retry</Button></Alert></Box></Box>;
  return children;
}
